import { TRAINING_EMPTY_VALUE } from './trainingEmptyValue';

export function formatTrainingControlValue(value: string | null | undefined): string {
  const trimmed = value?.trim();

  return trimmed ? trimmed : TRAINING_EMPTY_VALUE;
}
